module.exports = __webpack_public_path__ + "img/love-balloon.76c7c400.svg";